import React from 'react';
import PropTypes from 'prop-types';

const IpAddressList = ({ entity }) => {
    if (!entity?.ip_addresses?.length) {
        return (
            <div className="flex flex-col">
                <div>IP Addresses:</div>
                <span>-</span>
            </div>
        );
    }

    return (
        <div className="flex flex-col">
            <div>IP Addresses:</div>
            <div>
                {entity.ip_addresses.map((ip) => (
                    <div key={ip}>{ip}</div>
                ))}
            </div>
        </div>
    );
};

IpAddressList.propTypes = {
    entity: PropTypes.shape({
        ip_addresses: PropTypes.arrayOf(PropTypes.string),
    }).isRequired,
};

export default IpAddressList;
